import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isValidElement, Children, cloneElement, useContext } from 'react';
import PropTypes from 'prop-types';
import Context from '@gisatcz/cross-package-react-context';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var TimelineHover = function TimelineHover(_ref) {
  var getHoverContent = _ref.getHoverContent,
      children = _ref.children;
  var defaultHoverContext = 'TimeLineContext';
  var HoverContext = Context.getContext(defaultHoverContext);
  var context = useContext(HoverContext);
  var onHoverOut = context === null || context === void 0 ? void 0 : context.onHoverOut;

  var onHover = function onHover(evt) {
    var _popupContent$popup;

    var hoveredItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var popupContent = evt && getHoverContent(evt.x, evt.time, evt, context) || null;

    if (popupContent && ( /*#__PURE__*/isValidElement(popupContent) || popupContent !== null && popupContent !== void 0 && (_popupContent$popup = popupContent.popup) !== null && _popupContent$popup !== void 0 && _popupContent$popup.content)) {
      var hoverItem = {
        key: 'timeline',
        x: evt.x,
        y: evt.y
      };

      if (typeof (context === null || context === void 0 ? void 0 : context.onHover) === 'function') {
        context === null || context === void 0 ? void 0 : context.onHover([hoverItem].concat(_toConsumableArray(hoveredItems)), {
          popup: {
            x: evt.x,
            y: evt.y,
            content: popupContent
          }
        });
      }
    } else {
      if (typeof (context === null || context === void 0 ? void 0 : context.onHoverOut) === 'function') {
        context === null || context === void 0 ? void 0 : context.onHoverOut();
      }
    }
  };

  var childrenElms = Children.map(children, function (child) {
    return /*#__PURE__*/cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
      onHover: onHover,
      onHoverOut: onHoverOut
    }));
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: childrenElms
  });
};

TimelineHover.propTypes = {
  getHoverContent: PropTypes.func,
  children: PropTypes.node
};
export default TimelineHover;